import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectSidebarExpanded } from "../../store/sidebarSlice";
import { Wallet, User, Plus, Check, LogOut } from "lucide-react";
import { doc, onSnapshot, updateDoc, getDoc, collection, query, where } from "firebase/firestore";
import { db } from "../../config/firebase";
import { X, MailCheck } from "lucide-react";
import { useAppSelector, useAppDispatch } from "../../store/hooks";
import { AppDispatch, RootState } from "../../store";

import { IoClose } from "react-icons/io5";
import { useAppState } from "../../hooks/useAppState";
import { useWallet } from "../../hooks/useWallet";
import {
  addFunds,
  getWallet,
} from "../../services/walletService";
import { getFunctions, httpsCallable } from "firebase/functions";
import {
  createNotification,
  getUserNotifications,
  getAllNotifications,
} from "../../store/slices/notificationSlice";
import { useNavigate, useSearchParams } from "react-router-dom";
import NavbarNotification from "./NavbarNotification";
import requestFund from "../../assets/icons/requestFund.png";
import { fetchUserData } from "../../store/profileSlice";
import { updateUserProfile ,logActivity, updateAvailabilityFromListener } from "../../store/profileSlice";
import LoadingSpinner from "../common/LoadingSpinner";
import { logout } from "../../store/authSlice";

// import { logActivity } from "../../store/activitySlice";
const Navbar: React.FC = () => {
  const isExpanded = useSelector(selectSidebarExpanded);
  const { user } = useAppState();
  const dispatch = useAppDispatch();
console.log(user, "User data in Navbar")
  // Get profile data from redux state
  const profileData = useAppSelector((state: RootState) => state.profile.user);
  const expertProfile = useAppSelector(
    (state: RootState) => state.profile.expertProfile
  );
  const customerProfile = useAppSelector(
    (state: RootState) => state.profile.customerProfile
  );
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const orgData = useAppSelector(
    (state: RootState) => state.organization.currentOrganization
  );
  // Get name from appropriate profile based on user role
  const profileName =
    profileData?.name ||
    (user?.role === "Expert" ? expertProfile?.name : customerProfile?.name) ||
    user?.name;
    console.log(profileData,"profileData")
  // Add console log to debug profile name

  const { wallet, error } = useWallet();
  const [amount, setAmount] = useState(user?.amount || 0);
  const [requestFundModel, setRequestFundModel] = useState(false);
  const [requestAmount, setRequestAmount] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);
  const [modalIsOpenAddAmount, setModalIsOpenAddAmount] = useState(false);
  const [inputAmount, setInputAmount] = useState("");
  const [balanceSuccess, setBalanceSuccess] = useState(false);
  const [addedAmount, setAddedAmount] = useState(0);
  const [isProcessing, setIsProcessing] = useState(false);
  const [greeting, setGreeting] = useState("");
  // Add state for confirmation popup
  const [showAddConfirm, setShowAddConfirm] = useState(false);
  const [pendingAddAmount, setPendingAddAmount] = useState<string>("");
  // Add state for request funds confirmation popup
  const [showRequestConfirm, setShowRequestConfirm] = useState(false);
  const [pendingRequestAmount, setPendingRequestAmount] = useState<string>("");
  // Add state for >5000 amount popup
  const [showAddLimitPopup, setShowAddLimitPopup] = useState(false);
  // Add local state for expert availability
  const [formData, setFormData] = useState({
    availability: profileData?.availability ?? false,
    // ...other fields if needed...
  });
  const [availabilityLoading, setAvailabilityLoading] = useState(false);
  // Add hover state for tooltip
  const [showAvailabilityTooltip, setShowAvailabilityTooltip] = useState(false);
  // Add state for confirmation modal
  const [showAvailabilityConfirm, setShowAvailabilityConfirm] = useState(false);
  const [pendingAvailability, setPendingAvailability] = useState<boolean | null>(null);
  // Add state for profile dropdown
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);

  // Handle logout function
  const handleLogout = async () => {
    try {
      await dispatch(logout()).unwrap(); // Use unwrap() to handle the Promise
      // Clear any local storage or session data if needed
      localStorage.clear();
      sessionStorage.clear();
      // Redirect to signin page and refresh the page for complete state reset
      navigate("/signin", { replace: true });
      // window.location.reload();
    } catch (error) {
      console.error("Error logging out:", error);
      // Even if logout fails, redirect to signin page for security
      navigate("/signin", { replace: true });
      // window.location.reload();
    }
  };

  // Handle profile navigation
  const handleProfileNavigation = () => {
    if (user?.role === "Expert") {
      navigate("/expert/profile");
    } else if (user?.role === "Customer") {
      navigate("/user/profile");
    } else if (user?.role === "supporty_admin") {
      navigate("/admin/profile");
    } else {
      // Default fallback path
      navigate("/user/profile");
    }
    setShowProfileDropdown(false);
  };

  // Real-time sync with profile data changes
  useEffect(() => {
    // Sync formData availability with profile changes from Redux store
    setFormData((prev) => ({
      ...prev,
      availability: profileData?.availability ?? expertProfile?.availability ?? false,
    }));
  }, [profileData?.availability, expertProfile?.availability]);

  // Real-time listener for availability updates
  useEffect(() => {
    if (!user?.uid) return;

    let unsubscribe: (() => void) | null = null;

    const setupAvailabilityListener = async () => {
      try {
        // Listen to profiles collection for real-time availability updates
        const profilesRef = collection(db, "profiles");
        const profileQuery = query(profilesRef, where("userId", "==", user.uid));
        
        unsubscribe = onSnapshot(profileQuery, (snapshot) => {
          if (!snapshot.empty) {
            const profileDoc = snapshot.docs[0];
            const profileData = profileDoc.data();
            
            // Update local state immediately when availability changes
            setFormData((prev) => ({
              ...prev,
              availability: profileData?.availability ?? false,
            }));
            
            // Also dispatch to Redux store for global state management
            dispatch(updateAvailabilityFromListener({
              userId: user.uid,
              availability: profileData?.availability ?? false
            }));
          }
        });
      } catch (error) {
        console.error("Error setting up availability listener:", error);
      }
    };

    // Only set up listener for experts
    if (user?.role === "Expert" || user?.role === "expert_owner") {
      setupAvailabilityListener();
    }

    // Cleanup function
    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [user?.uid, user?.role, dispatch]);

  // Show confirmation modal before updating availability
  const handleAvailabilityToggle = () => {
    if (!user) return;
    setPendingAvailability(!formData.availability);
    setShowAvailabilityConfirm(true);
  };

  // Actually update availability after confirmation
  const confirmAvailabilityChange = async () => {
    if (!user || pendingAvailability === null) return;
    setFormData((prev) => ({
      ...prev,
      availability: pendingAvailability,
    }));
    setAvailabilityLoading(true);
    try {
      await dispatch(updateUserProfile({ ...formData, availability: pendingAvailability })).unwrap();
      // Optionally log activity
      if ( user?.uid) {
        dispatch(
          logActivity({
            userId: user.uid,
            type: "availability_update",
            metadata: { 
              details: `Availability set to ${pendingAvailability ? "Available" : "Unavailable"}` 
            },
          })
        );
      }
    } catch (error) {
      // Revert on error
      setFormData((prev) => ({
        ...prev,
        availability: !pendingAvailability,
      }));
      alert("Failed to update availability. Please try again.");
    } finally {
      setAvailabilityLoading(false);
      setShowAvailabilityConfirm(false);
      setPendingAvailability(null);
    }
  };

  useEffect(() => {
    // Function to update the greeting based on time of day
    const updateGreeting = () => {
      const hour = new Date().getHours();
      if (hour >= 5 && hour < 12) {
        setGreeting("Good morning!");
      } else if (hour >= 12 && hour < 18) {
        setGreeting("Good afternoon!");
      } else {
        setGreeting("Good evening!");
      }
    };

    // Update greeting immediately
    updateGreeting();

    // Set up interval to update greeting every minute
    const intervalId = setInterval(updateGreeting, 60000);

    // Clean up interval on unmount
    return () => clearInterval(intervalId);
  }, []); // Real-time notification polling
  useEffect(() => {
    // Initial fetch
    if (user?.uid) {
      if (user?.role === "supporty_admin") {
        dispatch(getAllNotifications());
      } else {
        dispatch(getUserNotifications(user.uid));
      }
    }

    // Set up interval for real-time updates (every 30 seconds)
    const interval = setInterval(() => {
      if (user?.uid) {
        if (user?.role === "supporty_admin") {
          dispatch(getAllNotifications());
        } else {
          dispatch(getUserNotifications(user.uid));
        }
      }
    }, 30000);

    // Clean up interval on unmount
    return () => clearInterval(interval);
  }, [dispatch, user?.uid, user?.role]);

   
  useEffect(() => {
    if (!user?.uid) return;
    // Subscribe to real-time updates
    const unsubscribe = onSnapshot(doc(db, "users", user.uid), (doc) => {
      if (doc.exists()) {
        const userData = doc.data();
        setAmount(userData.amount || 0);
        // Update the global user state
        // set({
        //   user: { ...user, amount: userData.amount || 0 },
        // });
      }
    });
    if (user?.teamRole === "customer_owner") {
      getWallet(user?.orgId);
    } else if (
      user?.teamRole === "customer_team_lead" ||
      user?.teamRole === "customer_team_member" ||
      user?.role === "supporty_admin"
    ) {
      getWallet(user?.uid);
    }
    // Cleanup subscription on unmount
    return () => unsubscribe();
  }, [user?.uid]);

  // Check URL params for addfundmodel and open appropriate modal
  useEffect(() => {
    if (searchParams.get('addfundmodel') === 'true') {
      if (user?.role === "Customer") {
        if (user?.teamRole === "customer_owner") {
          setModalIsOpenAddAmount(true);
        } else if (user?.teamRole === "customer_team_lead") {
          setRequestFundModel(true);
        }
      }
    }
  }, [searchParams, user]);

  const getInitialsImage = (name: string) => {
    if (!name) return null;
    const initials = name
      .split(" ")
      .map((part) => part.charAt(0).toUpperCase());
    return (
      <div className="flex items-center justify-center h-full text-white font-bold">
        {initials.join("")}
      </div>
    );
  };
  const onClose = () => {
    setRequestFundModel(false);
    setShowSuccess(false);
    setRequestAmount("");
  };
  const handleSendRequest = async () => {
    // Don't show success if amount is empty or not a valid number
    if (
      !requestAmount ||
      isNaN(Number(requestAmount)) ||
      Number(requestAmount) <= 0
    ) {
      return;
    }

    // If amount > 999, show confirmation popup first
    if (Number(requestAmount) > 999 && !showRequestConfirm) {
      setPendingRequestAmount(requestAmount);
      setShowRequestConfirm(true);
      return;
    }

    await processRequestFunds(requestAmount);
  };

  const processRequestFunds = async (amount: string) => {
    setIsProcessing(true);
    // Get Firebase Functions instance
    const functions = getFunctions();

    // Get the organization ID from the user object - fix the key name to match what's stored in user object
    const orgId = user?.orgId || "defaultOrgId";

    if (!orgId) {
      throw new Error("Organization ID not found. Please contact support.");
    }

    // Get the organization details to find the owner
    const orgRef = doc(db, "organizations", orgId);
    const orgSnapshot = await getDoc(orgRef);
    const orgDocData = orgSnapshot.exists() ? orgSnapshot.data() : null;

    // Define ownerUid from organization document data or fallback to orgData from state
    const ownerUid = orgDocData?.owner?.owner || orgData?.owner?.owner || orgId;

    const createInvitationFunc = httpsCallable(functions, "requestFund");

    // Prepare the data to send to the function with proper format
    const invitationData = {
      ownerUid: ownerUid, // Use the properly defined ownerUid here
      orgId: orgId, // Use the actual organization ID
      amount: Number(amount),
      description: "Funds requested",
    };

    try {
      // Call the function
      const result = await createInvitationFunc(invitationData);

      // Log the result to check if ownerUid is properly passed

      // Create notification for the fund request
      // Additional notification data preparation not needed since we already have ownerUid
      const notificationData = {
        userId: ownerUid, // Sending to the actual owner's UID, not orgData?.owner?.owner
        userEmail: user?.email || "Unknown",
        message: `Fund request of $${Number(amount).toFixed(2)} raised`,
        trigger: "fund_request_receive",
        triggeredBy: user?.uid || "unknown",
        // Additional data for better display and processing
        meta: {
          amount: Number(amount),
          requesterEmail: user?.email || "Unknown",
          requesterName: user?.name || profileName || "Team Member",
          requesterUid: user?.uid || "unknown",
          ownerUid: ownerUid,
          status: "pending",
          customerEmail: user?.email || "Unknown",
          requestId: result?.data?.requestId || result?.data?.data?.requestId,
          requestedAt: new Date().toISOString(),
        },
      };

      // Dispatch a single notification with all the data
      dispatch(createNotification(notificationData));

      // Also add a copy of the notification in the requester's notifications
      // This ensures the requester can track their request
      if (user?.uid && user?.uid !== ownerUid) {
        dispatch(
          createNotification({
            ...notificationData,
            userId: user.uid, // Send to requester
            message: `Your fund request of $${Number(amount).toFixed(
              2
            )} is pending approval`,
            trigger: "fund_request_send", // Different trigger for requester's view
          })
        );
      }

      console.log("Fund request notifications created successfully");
      setShowSuccess(true);
    } catch (error) {
      console.error("Failed to create fund request notification:", error);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleClose = () => {
    setBalanceSuccess(false);
  };
  const handleAddBalance = async (amount: string) => {
    if (!user?.uid || !amount || isNaN(Number(amount)) || Number(amount) <= 0) {
      return;
    }
    // If amount > 5000, show limit popup
    if (Number(amount) > 5000) {
      setPendingAddAmount(amount);
      setShowAddLimitPopup(true);
      return;
    }
    // If amount > 999, show confirmation popup first
    if (Number(amount) > 999 && !showAddConfirm) {
      setPendingAddAmount(amount);
      setShowAddConfirm(true);
      return;
    }

    try {
      setIsProcessing(true);
      const numAmount = Number(amount);

      // Get Firebase Functions instance      // Call the Firebase function to process the top-up
      try {
        const response = await fetch(
          `https://us-central1-supporty-staging.cloudfunctions.net/addTopup`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              userId: orgData?.wpCustomerId,
              amount: numAmount,
              currency: "USD",
            }),
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const responseData = await response.json();
        console.log("Parsed response data:", responseData);

        // Create notification for funds added
        if (user?.uid) {
          dispatch(
            createNotification({
              userId: user?.uid,
              userEmail: user?.email || "Unknown",
              message: `Amount $${numAmount.toFixed(
                2
              )} was added to your wallet`,
              trigger: "funds_added",
              triggeredBy: user?.uid || "unknown",
              meta: {
                amount: numAmount,
                walletId: wallet?.id || user.uid,
                addedAt: new Date().toISOString(),
                addedBy: user?.uid,
                adderName: user?.name || profileName || "User",
                previousBalance: wallet?.balance || 0,
                newBalance: (wallet?.balance || 0) + numAmount,
                paymentId: responseData.data?.paymentId,
                orderId: responseData.data?.orderId,
              },
            })
          );
        }
        if (responseData && responseData.success) {
          // Update local wallet service to reflect the changes
          await addFunds(
            wallet?.id || user?.uid,
            numAmount,
            user?.uid,
            "Wallet top-up via Stripe"
          );

          // Close modal and reset input
          setModalIsOpenAddAmount(false);
          setInputAmount("");

          // Show success popup
          setAddedAmount(numAmount);
          setBalanceSuccess(true);
        } else {
          throw new Error(responseData?.message || "Failed to process payment");
        }
      } catch (error) {
        console.error("Error calling addTopup function:", error);
        throw error; // Re-throw to be caught by outer catch block
      }
    } catch (error: any) {
      console.error("Error adding balance:", error);
      // Show error message to user
      alert(`Failed to add balance: ${error.message || "Unknown error"}`);
    } finally {
      setIsProcessing(false);
    }
  };
  // const handleNavigation = (path: string): void => {
  //   // Navigate to role-specific notification page based on user role
  //   if (user?.role === "Expert") {
  //     navigate("/expert/notification");
  //   } else if (user?.role === "Customer") {
  //     navigate("/user/notification");
  //   } else if (user?.role === "supporty_admin") {
  //     navigate("/admin/notification");
  //   } else {
  //     // Default fallback path
  //     navigate("/user/notification");
  //   }
  // }; // Handle fund request management
 useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(fetchUserData()).unwrap();
       
      } catch
  (error) {
          console.error("Error fetching user data:", error);
        }
    };

    fetchData();

   
  }, [dispatch]);
  return (
    <div
      className={`fixed top-0 right-0 ${
        isExpanded ? "left-60" : "left-20"
      } transition-all duration-300 bg-white z-10`}
    >
      {/* Top Navbar */}
      <div className="bg-[#F15D18] text-white p-4 flex justify-between items-center">
        <div className="ml-3 text-[20px] text-[#FFFFFF] nunito-medium">
          {greeting}
        </div>
        <div className="flex items-center gap-2">
          {user?.role == "Customer" && (
            <>
              {" "}
              {user?.teamRole === "customer_team_lead" && (
                <button
                  className="flex  h-[40px] items-center bg-[#FCE2D5] rounded-[10px] text-[#404040] text-[20px] nunito-semibold px-3 py-1.5 mr-4"
                  onClick={() => setRequestFundModel(true)}
                >
                  <img src={requestFund} className="w-[24px] h-[24px] mr-1" />
                  <span className=" text-gray-800 font-medium">
                    Request Funds
                  </span>
                </button>
              )}
              {user?.teamRole === "customer_owner" && (
                <button
                  className="flex  h-[40px] items-center bg-[#FCE2D5] rounded-[10px] text-[#404040] text-[20px] nunito-semibold px-3 py-1.5 mr-4"
                  onClick={() => setModalIsOpenAddAmount(true)}
                >
                  <Plus className="w-5 h-5 text-gray-600 mr-2" />
                  <span className=" text-gray-800 font-medium">
                    Add Balance
                  </span>
                </button>
              )}
            </>
          )}
          {user?.role === "Customer" && (
            <div className="flex  h-[40px] items-center bg-[#FCE2D5] rounded-[10px] text-[#404040] text-[20px] nunito-semibold px-3 py-1.5 mr-4">
              <Wallet className="w-5 h-5 text-gray-600 mr-2" />
              <span className="text-gray-800 font-medium">
                ${wallet?.balance?.toFixed(2)}
              </span>
            </div>
          )}
          {user?.role === "Expert" && (
            <div className="col-span-2 flex items-center gap-3 relative">
              <label className="text-[18px] text-white nunito-semibold">
                {" "}
{formData.availability ? "Available" : "Unavailable"}
              </label>
              <label
                className="relative inline-flex items-center cursor-pointer"
                onMouseEnter={() => setShowAvailabilityTooltip(true)}
                onMouseLeave={() => setShowAvailabilityTooltip(false)}
              >
                <input
                  type="checkbox"
                  checked={formData.availability || false}
                  onChange={handleAvailabilityToggle}
                  className="sr-only peer"
                  disabled={availabilityLoading}
                />
                <div className="w-[50px] h-[26px] bg-[#A8A8A8]   rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2.6px] after:left-[5px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-[20px] after:w-[20px] after:transition-all peer-checked:bg-[#4BB847]"></div>
                {/* Tooltip for availability */}
                {showAvailabilityTooltip && (
                  <div className="absolute left-1/2 -translate-x-1/2 top-10 bg-[#EBEBEB] text-black text-[14px] nunito-semibold rounded-[8px]  px-3 py-1 z-50 whitespace-nowrap shadow-lg">
                    {formData.availability ? "Available" : "Unavailable"}
                  </div>
                )}
              </label>
              <div>
               
              </div>
            </div>
          )}
         
          {/* Notifications Bell */}
          <NavbarNotification />

          <span>Hi, {profileName}</span>
          <div 
            className="relative"
            onMouseEnter={() => setShowProfileDropdown(true)}
            onMouseLeave={() => setShowProfileDropdown(false)}
          >
            <div
              className="w-8 h-8 bg-gray-200 rounded-full overflow-hidden cursor-pointer transition-opacity"
            >
              {user?.profileImageUrl ? (
                <img
                  src={user.profileImageUrl}
                  alt={profileName || "User"}
                  className="w-full h-full object-cover"
                />
              ) : (
                getInitialsImage(profileName || "")
              )}
            </div>
            
            {/* Dropdown Menu */}
            {showProfileDropdown && (
              <div className="absolute right-0 bg-white border border-gray-200 rounded-lg shadow-lg py-2 w-32 z-50">
                <button
                  onClick={handleProfileNavigation}
                  className="w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 flex items-center gap-2"
                >
                  <User className="w-4 h-4" />
                  Profile
                </button>
                <button
                  onClick={handleLogout}
                  className="w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 flex items-center gap-2"
                >
                  <LogOut className="w-4 h-4" />
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>

        {/* // Model  */}
        {/* Request Funds Model */}
        {requestFundModel && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30">
            {!showSuccess ? (
              <div className="bg-white rounded-2xl shadow-lg w-96 p-6 relative">
                <button
                  className="absolute top-4 right-4 text-[#696969]"
                  onClick={onClose}
                >
                  <X size={24} />
                </button>
                <h2 className="text-lg font-semibold text-[#0A0A0A] mb-4">
                  Request Funds
                </h2>{" "}
                <div className="mb-4 border rounded-lg border-[#D9D9D9] p-4">
                  <label className="text-sm font-medium text-[#404040]">
                    Amount
                  </label>
                  <input
                    type="number"
                    placeholder="Enter Amount"
                    value={requestAmount}
                    onChange={(e) => setRequestAmount(e.target.value)}
                    className="mt-1 w-full border border-gray-300 text-[#404040] rounded-lg p-2 focus:ring-2  focus:outline-none"
                    min="0"
                    disabled={isProcessing}
                  />
                  {requestAmount && Number(requestAmount) < 0 && (
                    <p className="text-red-500 text-sm mt-1">
                      Amount cannot be negative
                    </p>
                  )}
                </div>
                <div className=" flex justify-center">
                  <button
                    className="w-[120px] bg-[#F15D18] hover:bg-orange-600 text-white py-2 rounded-lg font-semibold disabled:bg-opacity-70 disabled:cursor-not-allowed"
                    onClick={handleSendRequest}
                    disabled={
                      isProcessing ||
                      !requestAmount ||
                      Number(requestAmount) <= 0
                    }
                  >
                    {isProcessing ? "Processing..." : "Send "}
                  </button>
                </div>
              </div>
            ) : (
              <div className="bg-white rounded-2xl shadow-lg p-6 w-96 text-center relative">
                <button onClick={onClose} className="absolute top-3 right-3">
                  <X className="w-5 h-5 text-gray-500" />
                </button>
                <div className="flex flex-col items-center">
                  <div className=" p-3  ">
                    <MailCheck className="w-20 h-20 text-[#696969] stroke-[1px]" />
                  </div>
                  <h1 className="text-orange-500 text-3xl font-semibold">
                    ${Number(requestAmount).toFixed(2)}
                  </h1>
                  <h1 className="text-gray-800 text-2xl  mt-2">
                    Request Successfully Sent
                  </h1>
                  <p className="text-gray-500 text-sm mt-2">
                    Wallet will be updated after team owner approves
                  </p>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Add Balance Modal */}
        {modalIsOpenAddAmount && (
          <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-[468px] h-[257px]">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-lg font-semibold text-[#0A0A0A]">
                  Add Balance
                </h2>
                <button
                  onClick={() => setModalIsOpenAddAmount(false)}
                  className="text-[#696969] text-[25px] "
                >
                  <IoClose className=" " />
                </button>
              </div>
              <div className=" border-[#EBEBEB] border-2 p-4 rounded-xl">
                <label className="block text-sm font-medium text-[#404040]">
                  Amount
                </label>
                <input
                  type="number"
                  placeholder="Enter Amount"
                  value={inputAmount}
                  onChange={(e) => setInputAmount(e.target.value)}
                  className="w-full p-2 border text-black rounded mt-1"
                  disabled={isProcessing}
                />
              </div>
              <div className="justify-center flex">
                <button
                  onClick={() => {
                    if (
                      !inputAmount ||
                      isNaN(Number(inputAmount)) ||
                      Number(inputAmount) <= 0
                    ) {
                      return;
                    }
                    if (Number(inputAmount) > 5000) {
                      setPendingAddAmount(inputAmount);
                      setModalIsOpenAddAmount(false);
                      setShowAddLimitPopup(true);
                    } else if (Number(inputAmount) > 999) {
                      setPendingAddAmount(inputAmount);
                      setShowAddConfirm(true);
                    } else {
                      handleAddBalance(inputAmount);
                    }
                  }}
                  className="w-[120px] mt-4 bg-[#F15D18] text-white py-2 rounded  disabled:bg-opacity-70 disabled:cursor-not-allowed "
                  disabled={
                    isProcessing ||
                    !inputAmount ||
                      isNaN(Number(inputAmount)) ||
                      Number(inputAmount) <= 0
                  }
                >
                  {isProcessing ? "Processing..." : "Add Now"}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Add Balance Confirmation Popup */}
        {showAddConfirm && (
          <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-6  w-[500px] h-[260px]  text-center relative">
              <button
                onClick={() => {
                  setShowAddConfirm(false);
                  setPendingAddAmount("");
                }}
                className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
              >
                <X size={24} />
              </button>
              <div className="mb-6 mt-8 text-[20px] text-gray-800 nunito-semibold">
                You're about to add ₹{pendingAddAmount} to your wallet. Ready to add this amount?
              </div>
              <div className="flex justify-center  gap-4 mt-4">
                <button
                className="py-2 w-[120px] h-[40px] bg-[#F15D18] items-center text-[16px] text-[#FFFFFF] nunito-semibold rounded-[8px] hover:bg-orange-600"
                 onClick={async () => {
                    setShowAddConfirm(false);
                    await handleAddBalance(pendingAddAmount);
                    setPendingAddAmount("");
                  }}
                  disabled={isProcessing}
                >
                  Yes
                </button>
                <button
                className="py-2 border w-[120px] h-[40px] items-center border-[#F15D18] text-[#F15D18] nunito-semibold rounded-[8px] "
                    onClick={() => {
                    setShowAddConfirm(false);
                    setPendingAddAmount("");
                  }}
                  disabled={isProcessing}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        )}
 {/* Availability Confirmation Modal */}
          {showAvailabilityConfirm && (
            <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
              <div className="bg-white rounded-lg shadow-lg p-4 w-[600px] text-center relative">
                <button
                  onClick={() => {
                    setShowAvailabilityConfirm(false);
                    setPendingAvailability(null);
                  }}
                  className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
                >
                  <X size={24} />
                </button>
                <div className="mb-6 mt-8 text-gray-800 ">
                
                  {pendingAvailability ? (<>
                  <div>
                    <h2 className="text-[20px] nunito-semibold">Make yourself Available?  </h2>
                    <p className="text-[18px] nunito-regular"> Turning Availability ON will make you visible to users. You will start receiving support requests as soon as users submit requests. Are you sure you want to mark yourself 'Available'?</p></div></>):(<> <div>
                        <h2 className="text-[20px] nunito-semibold">Go offline and stop receiving support requests?  </h2>
                    <p className="text-[18px] nunito-regular">  Turning Availability OFF will tag you as 'Unavailable' for users. You will no longer receive new support requests until you are Available again. Are you sure you want to mark yourself 'Unavailable'?</p></div></>)}

                </div>
                
                <div className="flex justify-center gap-4 mt-4">
                  <button
                 className="py-2 w-[120px] h-[40px] bg-[#F15D18] items-center text-[16px] text-[#FFFFFF] nunito-semibold rounded-[8px] hover:bg-orange-600"
                   onClick={confirmAvailabilityChange}
                    disabled={availabilityLoading}
                  >
                  {availabilityLoading ? (
                    "Processing..."
                  ) : (
                    "Yes"
                  )}
                  </button>
                  <button
                    className="py-2 border w-[120px] h-[40px] items-center border-[#F15D18] text-[16px] text-[#F15D18] nunito-semibold rounded-[8px] "
               onClick={() => {
                      setShowAvailabilityConfirm(false);
                      setPendingAvailability(null);
                    }}
                    disabled={availabilityLoading}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          )}
        {/* Balance Success Popup */}
        {balanceSuccess && (
          <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg w-[450px] h-[250px] p-6 relative text-center shadow-lg">
              {/* Close Button */}
              <button
                onClick={handleClose}
                className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
              >
                <X size={24} />
              </button>

              {/* Check Icon */}
              <div className="flex justify-center mt-1">
                <div className="bg-[#4BB847] border-gray-100 border-[10px] rounded-full p-4 flex items-center justify-center">
                  <Check className="text-white w-[80px] h-[80px]" />
                </div>
              </div>
              <div className="">
                {/* Amount */}
                <p className="text-2xl font-bold text-orange-500 mt-4">
                  ${addedAmount.toFixed(2)}
                </p>

                {/* Success Message */}
                <p className="text-gray-700 text-2xl mt-1 font-medium">
                  Successfully Added
                </p>
              </div>
            </div>
          </div>
        )}
        {/* Add Balance Limit Modal (>5000) */}
        {showAddLimitPopup && (
          <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-[500px] text-center relative">
              <div className="mb-6 mt-8 text-[20px] text-gray-800 nunito-semibold">
                Oops! You can only add up to ₹5,000 at a time.
              </div>
              <div className="flex justify-center gap-4 mt-4">
                <button
                  className="py-2 w-[160px] h-[40px] bg-[#F15D18] items-center text-[16px] text-[#FFFFFF] nunito-semibold rounded-[8px] hover:bg-orange-600"
                  onClick={() => {
                    setShowAddLimitPopup(false);
                    setModalIsOpenAddAmount(true);
                    setInputAmount(pendingAddAmount);
                  }}
                >
                  Change Amount
                </button>
              </div>
            </div>
          </div>
        )}
        {/* Request Funds Confirmation Popup */}
        {showRequestConfirm && (
          <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-[500px] h-[260px] text-center relative">
              <button
                onClick={() => {
                  setShowRequestConfirm(false);
                  setPendingRequestAmount("");
                }}
                className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
              >
                <X size={24} />
              </button>
              <div className="mb-6 mt-8 text-[20px] text-gray-800 nunito-semibold">
                You're about to request ${pendingRequestAmount} from your team owner. Ready to send this request?
              </div>
              <div className="flex justify-center gap-4 mt-4">
                <button
                  className="py-2 w-[120px] h-[40px] bg-[#F15D18] items-center text-[16px] text-[#FFFFFF] nunito-semibold rounded-[8px] hover:bg-orange-600"
                  onClick={async () => {
                    setShowRequestConfirm(false);
                    await processRequestFunds(pendingRequestAmount);
                    setPendingRequestAmount("");
                  }}
                  disabled={isProcessing}
                >
                  Yes
                </button>
                <button
                  className="py-2 border w-[120px] h-[40px] items-center border-[#F15D18] text-[#F15D18] nunito-semibold rounded-[8px]"
                  onClick={() => {
                    setShowRequestConfirm(false);
                    setPendingRequestAmount("");
                  }}
                  disabled={isProcessing}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;
